import {
    VESSEL_LIST,
    VESSEL_PAGINATION
} from './constant';

export const initStateFeed = {
    vesselList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case VESSEL_LIST: {
            return {
                ...state,
                vesselList: action.payload,
            };
        }
        case VESSEL_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
 